import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { environment } from '../../../../environments/environment';
import { OtherKpModel } from '../models/other-kp-model';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { DistributorOtherKp } from '../models/distributor-other-kp';
import { DistributorType } from '../../home/models/distributor-type';
import { Nomenclature } from '../models/nomenclature';

const apiServer = environment.apiServer;

@Injectable()
export class OtherKpDetailService {
  isNew: boolean = false
  viewKpNumber: string = "Новый";
  newCustomerInn: string = "";
  newCustomerName: string = "";
  isHaveErrors: boolean = false
  
  private messageDistributerAuction = new BehaviorSubject<DistributorOtherKp>(new DistributorOtherKp());
  private currentStateDistributerAuction = new DistributorOtherKp();

  currentOtherKp = new OtherKpModel()
  otherKp = new BehaviorSubject<OtherKpModel>(new OtherKpModel())
  otherKp$ = this.otherKp.asObservable();
  
  private reload$ = new Subject<void>();
  reloadTable$ = this.reload$.asObservable();

  private triggerSave$ = new Subject<void>();
  triggerSaveObserver$ = this.triggerSave$.asObservable();

  preSelectedNomenclature: Array<Nomenclature> = []

  private preSelectedNomenclaturesUpdate$ = new Subject<void>();
  preSelectedNomenclatures$ = this.preSelectedNomenclaturesUpdate$.asObservable();

  constructor(private client: HttpClient) {
  }

  changeNomenclature(nomenclatureList: Array<number>) {
    this.currentOtherKp.nomenclatureList = []
    Object.keys(nomenclatureList).forEach(key => {
      if (nomenclatureList[key] != null) {
        this.currentOtherKp.nomenclatureList[key] = { goodId: nomenclatureList[key] }
      }
    });

    this.updateTempData()
  }

  updateTempData(spinner: NgxSpinnerService = null) {
    this.client.put<OtherKpModel>(`${apiServer}/otherKp/putTemp`, this.currentOtherKp).subscribe(result => {
      this.currentOtherKp = result
      this.otherKp.next(this.currentOtherKp)
      if (spinner != null) {
        spinner.hide();
      }
    });
  }

  public putOtherKp(otherKp: OtherKpModel, spinner: NgxSpinnerService = null) {
    this.client.put<OtherKpModel>(`${apiServer}/otherKp/putDetail`, otherKp).subscribe(result => {
      this.currentOtherKp = result
      this.viewKpNumber = this.currentOtherKp.id
      this.isNew = false
      this.otherKp.next(this.currentOtherKp)
      if (spinner != null) {
        spinner.hide();
      }
      this.triggerReload()
    });
  }

  public getNew(spinner: NgxSpinnerService = null) {
    this.isNew = true
    this.viewKpNumber = "Новый"
    this.client.get<OtherKpModel>(`${apiServer}/otherKp/getOtherKpId`).subscribe(result => {
      this.currentOtherKp = result
      this.currentOtherKp.statusST = "Новый"
      this.currentOtherKp.statusKP = "Новый"
      this.otherKp.next(this.currentOtherKp)
      if (spinner != null) {
        spinner.hide();
      }
    });
  }

  public openOtherKp(otherKp: OtherKpModel, spinner: NgxSpinnerService = null) {
    this.viewKpNumber = this.currentOtherKp.id
    this.isNew = false
    this.client.put<OtherKpModel>(`${apiServer}/otherKp/getOtherKpData`, otherKp).subscribe(result => {
      this.currentOtherKp = result
      this.viewKpNumber = this.currentOtherKp.id
      this.isNew = false
      this.otherKp.next(this.currentOtherKp)
      if (spinner != null) {
        spinner.hide();
      }
    });
  }

  triggerReload() {
    this.reload$.next();
  }

  triggerSave(): Promise<boolean> {
    this.triggerSave$.next();
    return new Promise(resolve => setTimeout(() => { 
      resolve(this.isHaveErrors) 
    }, 2000))
  }

  triggerReloadNomenclatures(){
    this.preSelectedNomenclature = this.currentOtherKp.nomenclatureList
    this.preSelectedNomenclaturesUpdate$.next()
  }

  changeDistributerAuction(distribAuction: DistributorOtherKp) {
    Object.keys(distribAuction).forEach(key => {
      if (distribAuction != null && distribAuction[key] != null) {
        this.currentStateDistributerAuction[key] = distribAuction[key];
      }
    });
    this.messageDistributerAuction.next(this.currentStateDistributerAuction);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/services/other-kp-detail.service.ts